// index.js

import {
  getOriginalCounterPart,
  getClones,
  checkClonesPosition,
  getInitialSlideInInfiniteMode
} from "./clones";
import {
  getWidthFromDeviceType,
  getPartialVisibilityGutter,
  getItemClientSideWidth
} from "./elementWidth";
import {
  getInitialState,
  getIfSlideIsVisbile,
  getTransformForCenterMode,
  getTransformForPartialVsibile,
  isInLeftEnd,
  isInRightEnd,
  notEnoughChildren,
  getSlidesToSlide
} from "./common";
import throttle from "./throttle";
import throwError from "./throwError";
import { populateNextSlides } from "./next";
import { populatePreviousSlides } from "./previous";
import { populateSlidesOnMouseTouchMove } from "./mouseOrTouchMove";

export {
  isInLeftEnd,
  isInRightEnd,
  getOriginalCounterPart,
  getClones,
  getSlidesToSlide,
  getWidthFromDeviceType,
  checkClonesPosition,
  getItemClientSideWidth,
  getPartialVisibilityGutter,
  throttle,
  getInitialState,
  getIfSlideIsVisbile,
  getTransformForCenterMode,
  getTransformForPartialVsibile,
  throwError,
  populateNextSlides,
  populatePreviousSlides,
  populateSlidesOnMouseTouchMove,
  notEnoughChildren,
  getInitialSlideInInfiniteMode
};
